import { createRouter, createWebHistory } from "vue-router";
import HomePage from "./views/Home.vue";
import AboutPage from "./views/AboutPage.vue";
import EasiestHardestCoursesPage from "./views/EasiestHardestCoursesPage.vue";
import PrivacyPage from "./views/PrivacyPage.vue";
import TermsPage from "./views/TermsPage.vue";
import AccountPage from "./views/AccountPage.vue";

const envFlag = (value, defaultValue = false) => {
  if (value == null || value === "") return defaultValue;
  return ["1", "true", "yes", "on"].includes(String(value).toLowerCase());
};

const isProdBuild = process.env.NODE_ENV === "production";
const premiumEnabled = envFlag(process.env.VUE_APP_PREMIUM_ENABLED, !isProdBuild);
const advancedEnabled = envFlag(process.env.VUE_APP_ADVANCED_ENABLED, !isProdBuild);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    meta: {
      seo: {
        titleKey: "seo.home.title",
        descriptionKey: "seo.home.description",
        canonicalPath: "/",
        robots: "index,follow",
        schemaType: "WebSite",
      },
    },
  },
  {
    path: "/course/:courseCode?",
    name: "homeWithCourse",
    component: HomePage,
    props: true,
    meta: {
      seo: {
        title: (route, t) =>
          t("seo.course.title", {
            code: String(route?.params?.courseCode || t("seo.course.unknownCode")),
          }),
        description: (route, t) =>
          t("seo.course.description", {
            code: String(route?.params?.courseCode || t("seo.course.unknownCode")),
          }),
        canonicalPath: (route) => {
          const rawCode = String(route?.params?.courseCode || "").trim();
          if (!rawCode) return "/";
          return `/course/${encodeURIComponent(rawCode)}`;
        },
        robots: "index,follow",
        schemaType: "Course",
      },
    },
  },
  {
    path: "/about",
    name: "about",
    component: AboutPage,
    meta: {
      seo: {
        titleKey: "seo.about.title",
        descriptionKey: "seo.about.description",
        canonicalPath: "/about",
        robots: "index,follow",
        schemaType: "WebPage",
      },
    },
  },
  {
    path: "/explore",
    name: "CourseCatalog",
    component: () => import("./views/CourseCatalogPage.vue"),
    meta: {
      seo: {
        title: "Finn og sammenlign emner | OnlyGrades",
        description: "Utforsk emner ved studiestedet ditt og sammenlign historiske karakterer og strykandel.",
        canonicalPath: "/explore",
        robots: "index,follow",
        schemaType: "CollectionPage",
      },
    },
  },
  {
    path: "/easiest-hardest-courses",
    name: "EasiestHardestCourses",
    component: EasiestHardestCoursesPage,
    meta: {
      seo: {
        titleKey: "seo.easiestHardest.title",
        descriptionKey: "seo.easiestHardest.description",
        canonicalPath: "/easiest-hardest-courses",
        robots: "index,follow",
        schemaType: "CollectionPage",
      },
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: PrivacyPage,
    meta: {
      seo: {
        titleKey: "seo.privacy.title",
        descriptionKey: "seo.privacy.description",
        canonicalPath: "/privacy",
        robots: "index,follow",
        schemaType: "WebPage",
      },
    },
  },
  {
    path: "/terms",
    name: "Terms",
    component: TermsPage,
    meta: {
      seo: {
        titleKey: "seo.terms.title",
        descriptionKey: "seo.terms.description",
        canonicalPath: "/terms",
        robots: "index,follow",
        schemaType: "WebPage",
      },
    },
  },
  {
    path: "/premium",
    name: "Premium",
    component: () => import("./views/PremiumPage.vue"),
    meta: {
      seo: {
        titleKey: "seo.premium.title",
        descriptionKey: "seo.premium.description",
        canonicalPath: "/premium",
        robots: "index,follow",
        schemaType: "WebPage",
      },
    },
  },
];

if (premiumEnabled) {
  routes.push(
    {
      path: "/account",
      name: "Account",
      component: AccountPage,
      meta: {
        seo: {
          titleKey: "seo.account.title",
          descriptionKey: "seo.account.description",
          canonicalPath: "/account",
          robots: "noindex,nofollow",
          schemaType: "WebPage",
        },
      },
    }
  );
}

if (advancedEnabled) {
  routes.push({
    path: "/advanced",
    name: "Advanced",
    component: () => import("./views/AdvancedPage.vue"),
    meta: {
      seo: {
        titleKey: "seo.advanced.title",
        descriptionKey: "seo.advanced.description",
        canonicalPath: "/advanced",
        robots: "noindex,follow",
        schemaType: "WebPage",
      },
    },
  });
}

routes.push({
  path: "/:pathMatch(.*)*",
  redirect: "/",
});

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
